export const SUMSUB_REDIRECTION_TIMEOUT = 5 * 1000;
